import React from 'react';
import { observer } from 'mobx-react';
import C3Chart from 'react-c3js';

import Panel from '../../commons/Panel';
import EvolucaoDialog from '../../commons/EvolucaoDialog';

import EvolucaoStore from '../../../stores/EvolucaoStore';
import SelecaoStore from '../../../stores/SelecaoStore';
import UIStore from '../../../stores/UIStore';

class Validos extends React.Component {
  state = { vagas: 0 };

  componentWillMount() {
    UIStore.init('Gráfico Votos Válidos', null, null, false, () =>
      SelecaoStore.loadCandidatos('ESTIMULADO')
    );
    SelecaoStore.candidatos = [];
    SelecaoStore.loadCandidatos('ESTIMULADO');
  }

  render() {
    this.candidatos = SelecaoStore.candidatos.filter(c => c.candidato);
    this.candidatos.sort((c1, c2) => c2.media - c1.media);

    let vagas = {
      type: 'bar',
      labels: true,
      x: 'candidato',
      columns: [
        ['candidato', ...this.candidatos.map(c => [c.candidato.nome])],
        ['total', ...this.candidatos.map(c => [c.valido])],
      ],
      color: (color, d) => {
        return this.candidatos[d.x]
          ? this.candidatos[d.x].candidato.partido.cor
          : '#ccc';
      },
    };

    return (
      <React.Fragment>
        <Panel
          title="Válidos"
          loadHistory={() => EvolucaoStore.loadCandidatosMajoritarios('VALIDO')}
        >
          <C3Chart
            style={{ height: '520px', maxHeight: '520px' }}
            data={vagas}
            axis={{ rotated: true, x: { type: 'category' } }}
            legend={{ show: false }}
          />
        </Panel>
        <EvolucaoDialog
          title="Evolução dos Candidatos"
          opened={EvolucaoStore.candidatos != null}
          data={EvolucaoStore.candidatos}
          onOK={() => (EvolucaoStore.candidatos = null)}
        />
      </React.Fragment>
    );
  }
}

export default observer(Validos);



// WEBPACK FOOTER //
// ./src/components/majoritario/validos/index.js